const state = () => ({
  link: null,
});

// mutations
const mutations = {
  setLink(currentState, value) {
    currentState.link = value;
  },
};

const getters = {
  link: (currentState) => currentState.link,
};

export default {
  namespaced: true,

  mutations,
  state,
  getters,
};
